module.exports = __webpack_public_path__ + "img/og-image_pocket_cn.57c771c.jpg";